import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=1ab5ddc7&scoped=true&lang=pug&"
import script from "./GeneralForm.vue?vue&type=script&lang=js&"
export * from "./GeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=1ab5ddc7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5ddc7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VTextField})
